<template>
  <div class="app-layout">
    <HeaderNavigation>
      <div class="d-flex flex-column min-vh-100">
        <div class="flex-grow-1">
          <slot />
        </div>
      </div>
    </HeaderNavigation>
  </div>
</template>
<script setup>
import HeaderNavigation from "@/components/navigations/HeaderNavigation.vue";
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
}
</style>
